import React, { Component } from 'react';
import Router from '@/containers/Router/Router'

class App extends Component {
  render() {
      return (
          <Router />
      )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js